import { Col, Form, FormControl, FormGroup, Image, Row } from "react-bootstrap";

import { useTranslateContext } from "../../contexts/translate.context";
import { maxString, toFloat, toInt, toStringFloat, toString } from "../../utilities/auxiliary-functions";
import { getDeliveryStatus } from "../../utilities/types";
import { ENormApplicant } from "../modals/delivery.cadastre.modal";

export interface IDeliveryRecordProps {
    title: any,
    isEdit: boolean,
    identifier: boolean,
    viewOnly?: boolean,

    normApplicant: any,
    setNormApplicant: any,
    listApplicant: any,

    listGroup: any,
    listSubgroup: any,
    listProductItem: any,

    group: any,
    subgroup: any,
    setGroup: any,
    setSubgroup: any,
    
    created?: any,
    updated?: any,
    setCreated?: any,
    setUpdated?: any,

    launch: any,
    applicant: any,
    applicantId: any,
    status: any,
    payment: any,
    operator: any,
    quantity: any,
    amount: any,
    setLaunch: any,
    setApplicant: any,
    setApplicantId: any,
    setStatus: any,
    setPayment: any,
    setOperator: any,
    setQuantity: any,
    setAmount: any,

    onChangeNormApplication: any,
    onChangeGroup: any,
    onChangeProducts: any,
    onChangeProductItem: any,
}

export const DeliveryRecord: React.FC<IDeliveryRecordProps> = (props: IDeliveryRecordProps) => {

    const { display } = useTranslateContext();

    function onChangeGroup(event: any) {
        event.preventDefault();
        let value = event.target.value;
        props.setGroup(value);
        props.onChangeGroup(event);
        props.onChangeProducts(event, value);
    }

    function onChangeSubgroup(event: any) {
        event.preventDefault();
        let value = event.target.value;
        props.setSubgroup(value);
        props.onChangeProducts(event, props.group, value);
    }

    function onChangeNormApplication(event: any) {
        event.preventDefault();
        props.setNormApplicant(event.target.value);
        props.onChangeNormApplication(event);
    }

    function onChangeProductItem(event: any, position: number, productItem: any) {
        props.onChangeProductItem(event, position, productItem);
    }

    return (
        <>
            <Row>
                <Col sm="3">
                    <Row>
                        <Col>
                            <FormGroup>
                                <Form.Label htmlFor="form-launch">{display.label.date_launch}</Form.Label>
                                <Form.Control id="form-launch" name="launch" placeholder={display.example.launch}
                                    disabled={!props.isEdit}
                                    readOnly={true}
                                    value={props.launch}
                                    onChange={(e: any) => props.setLaunch(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Form.Label htmlFor="form-status">{display.label.status}</Form.Label>
                                <Form.Control id="form-status" name="status" placeholder={display.example.status}
                                    disabled={!props.isEdit}
                                    readOnly={true}
                                    value={getDeliveryStatus(props.status)}
                                    onChange={(e: any) => props.setStatus(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </Col>
                <Col sm="9">
                    <Row>
                        <Col sm="4">
                            <div key={`inline-radio`} className="mt-1">
                                <Form.Check inline name="norm-applicant" label="Embarcação" type='radio' id='form-norm-applicant-1' 
                                    checked={toInt(props.normApplicant) === ENormApplicant.VESSEL}
                                    value={0} 
                                    onChange={(e: any) => onChangeNormApplication(e)} 
                                />
                                <Form.Check inline name="norm-applicant" label="Cliente" type='radio' id='form-norm-applicant-2' 
                                    checked={toInt(props.normApplicant) === ENormApplicant.MEMBER}
                                    value={1} 
                                    onChange={(e: any) => onChangeNormApplication(e)} 
                                />
                                <Form.Check inline name="norm-applicant" label="Funcionario" type='radio' id='form-norm-applicant-3' 
                                    checked={toInt(props.normApplicant) === ENormApplicant.EMPLOYEE}
                                    value={2} 
                                    onChange={(e: any) => onChangeNormApplication(e)} 
                                />
                                <Form.Check inline name="norm-applicant" label="Nome" type='radio' id='form-norm-applicant-4' 
                                    checked={toInt(props.normApplicant) === ENormApplicant.OTHER}
                                    value={3} 
                                    onChange={(e: any) => onChangeNormApplication(e)} 
                                />
                            </div>
                        </Col>
                        <Col sm="8">
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Form.Label htmlFor="form-applicant">{display.label.applicant}</Form.Label>
                                        {toInt(props.normApplicant) === ENormApplicant.VESSEL || 
                                            toInt(props.normApplicant) === ENormApplicant.MEMBER ||
                                            toInt(props.normApplicant) === ENormApplicant.EMPLOYEE ? (
                                            <Form.Select id="form-applicant" name="applicant"  
                                                disabled={!props.isEdit}
                                                value={props.applicantId} 
                                                onChange={(e: any) => props.setApplicantId(e.target.value)}
                                            >
                                                { props.applicant === "" || props.applicant === "VESSEL" || props.applicant === "MEMBER"  || props.applicant === "EMPLOYEE" ? (
                                                    <option value="">...</option>
                                                ) : null }
                                                { props.listApplicant.map((iterator: any, idx: number) => (<option key={idx} value={iterator.id}>{iterator.name}</option>))}
                                            </Form.Select>
                                        ) : (
                                            <FormControl id="form-applicant" name="applicant" placeholder={display.example.applicant}
                                                disabled={!props.isEdit}
                                                value={props.applicant}
                                                onChange={e => props.setApplicant(e.target.value)}
                                            />
                                        )}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Form.Label htmlFor="form-payment">{display.label.payment}</Form.Label>
                                            <Form.Select id="form-payment" name="payment"  
                                                disabled={!props.isEdit}
                                                value={props.payment} 
                                                onChange={(e: any) => props.setPayment(e.target.value)}
                                            >
                                                <option value="MONTHLY">Mensalista</option>
                                                <option value="SINGLE">Avulso</option>
                                            </Form.Select>

                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row sm="12" className="ms-1 me-1"><Col className="ps-1 pe-1" ><hr /></Col></Row>
            <Row>
                <Col sm="3">
                    <FormGroup>
                        <Form.Label htmlFor="form-group">{display.label.group}</Form.Label>
                        <Form.Select id="form-group" name="group"  
                            disabled={!props.isEdit}
                            value={props.group} 
                            onChange={(e: any) => onChangeGroup(e)}
                        >
                            { props.group === "" ? (
                                <option value="">...</option>
                            ) : null }
                            { props.listGroup.map((iterator: any, idx: number) => (<option key={idx} value={iterator.group}>{iterator.group}</option>)) }
                        </Form.Select>
                    </FormGroup>
                </Col>
                <Col sm="3">
                    <FormGroup>
                        <Form.Label htmlFor="form-subgroup">{display.label.subgroup}</Form.Label>
                        <Form.Select id="form-subgroup" name="subgroup"  
                            disabled={!props.isEdit}
                            value={props.subgroup} 
                            onChange={(e: any) => onChangeSubgroup(e)}
                        >
                            { props.subgroup === "" ? (
                                <option value="">...</option>
                            ) : null }
                            { props.listSubgroup.map((iterator: any, idx: number) => (<option key={idx} value={iterator.subgroup}>{iterator.subgroup}</option>)) }
                        </Form.Select>
                    </FormGroup>
                </Col>
                <Col sm="5"></Col>
                <Col sm="1" style={{ fontSize: '1.5rem', textAlign: 'right' }}>{props.listProductItem.length}</Col>
            </Row>
            <Row>
                <Col style={{ background: '#536d88', height: '355px', overflowX: 'auto', margin: '10px 5px 0', borderRadius: '4px' }}>
                    { props.listProductItem.map((deliveryItem: any, index: number) => (
                    <Row key={`item-${index}`} style={{ borderBottom: '1px solid #000000', padding: '10px 0' }}>
                        <Col sm="8">
                            <Row>
                                <Col sm="2" className="m-0 p-0">
                                    <Image src={deliveryItem.stock.product.image1} style={{ width: '100px', height: '100px'}} />
                                </Col>
                                <Col className="m-0 p-0">
                                    <Row style={{ height: '80%' }}>
                                        <Col>
                                            {deliveryItem.stock.product.description.length > 40 ? maxString(deliveryItem.stock.product.description, 240) : deliveryItem.stock.product.description}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="3"><strong>Estoque:</strong> {deliveryItem.stock.actual}</Col>
                                        <Col sm="5"><strong>Preço de Venda:</strong> {toStringFloat(deliveryItem.stock.sale)}</Col>
                                        <Col sm="4"><strong>Desconto:</strong> {toStringFloat(0)}</Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col sm="4">
                            <Row>
                                <Col className="m-0 p-0">
                                    <Row>
                                        <Col sm="5" className="m-0 ps-1">
                                            <FormGroup>
                                                <Form.Label htmlFor="form-quantity">{display.label.quantity}</Form.Label>
                                                <FormControl type="number" id="form-quantity" name="quantity" placeholder={display.example.quantity}
                                                    min={0}
                                                    max={deliveryItem.stock.actual}
                                                    style={{ textAlign: 'right' }}
                                                    disabled={!props.isEdit}
                                                    value={deliveryItem.quantity}
                                                    onChange={e => onChangeProductItem(e, index, {...deliveryItem, quantity: toInt(e.target.value) })}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm="7" className="m-0 ps-1">
                                            <FormGroup>
                                                <Form.Label htmlFor="form-amount">{display.label.amount}</Form.Label>
                                                <FormControl id="form-amount" name="amount" placeholder={display.example.amount}
                                                    style={{ textAlign: 'right' }}
                                                    readOnly={true}
                                                    disabled={!props.isEdit}
                                                    value={toStringFloat(deliveryItem.quantity * deliveryItem.stock.sale)}
                                                    onChange={e => onChangeProductItem(e, index, {...deliveryItem, amount: toFloat(e.target.value) })}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="m-0 p-1">
                                            <FormGroup>
                                                <Form.Label htmlFor="form-observation">{display.label.observation}</Form.Label>
                                                <FormControl id="form-observation" name="observation" placeholder={display.example.observation}
                                                    disabled={!props.isEdit}
                                                    value={toString(deliveryItem.observation)}
                                                    onChange={e => onChangeProductItem(e, index, {...deliveryItem, observation: e.target.value })}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    ))}
                </Col>
            </Row>
            <Row className="ms-1 me-1"><Col sm="12" className="ps-1 pe-1" ><hr /></Col></Row>
            <Row>
                <Col sm="8"></Col>
                <Col sm="4">
                    <Row>
                        <Col sm="5">
                            <FormGroup>
                                <Form.Label htmlFor="form-quantity">{display.label.quantity}</Form.Label>
                                <Form.Control id="form-quantity" name="quantity" placeholder={display.example.quantity}
                                    style={{ textAlign: 'right'}}
                                    disabled={!props.isEdit}
                                    readOnly={true}
                                    value={props.quantity}
                                    onChange={(e: any) => props.setQuantity(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm="7">
                            <FormGroup>
                                <Form.Label htmlFor="form-amount">{display.label.amount}</Form.Label>
                                <Form.Control id="form-amount" name="amount" placeholder={display.example.amount}
                                    style={{ textAlign: 'right'}}
                                    disabled={!props.isEdit}
                                    readOnly={true}
                                    value={toStringFloat(props.amount)}
                                    onChange={(e: any) => props.setAmount(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );

}

export default DeliveryRecord;
    